export const ACTIVE_EXPERIMENTS_COOKIE = 'x-nux'
